import { render, staticRenderFns } from "./communityMember.vue?vue&type=template&id=e3838268&scoped=true"
import script from "./communityMember.vue?vue&type=script&lang=js"
export * from "./communityMember.vue?vue&type=script&lang=js"
import style0 from "./communityMember.vue?vue&type=style&index=0&id=e3838268&prod&scoped=true&lang=css"
import style1 from "./communityMember.vue?vue&type=style&index=1&id=e3838268&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3838268",
  null
  
)

export default component.exports